import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fa-solid fa-star-half-stroke"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratingValue, (index) => {
      return (_openBlock(), _createElementBlock("i", {
        class: "fa-solid fa-star",
        key: index
      }))
    }), 128)),
    (!_ctx.isFullNumber)
      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.missingRating, (index) => {
      return (_openBlock(), _createElementBlock("i", {
        class: "fa-regular fa-star",
        key: index
      }))
    }), 128))
  ], 64))
}